import React, {useEffect, useContext, useState} from 'react'
import axios from 'axios';
import {Context} from '../../store/Store'
import {Link} from 'react-router-dom'

export default function SignUp(props) {
  const [values, setValues] = React.useState({
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    password: '',
    showPassword: false,
  });
  const [state, dispatch] = useContext(Context);
  const [signUpSource, setSignUpSource] = useState('');
  useEffect(() => {
    setSignUpSource(state.signUpSource);
  }, [state.signUpSource])

  // const [infoComplete, setInfoComplete] = React.useState(false);

  const handleChange = (property) => (event) => {
    let value = event.target.value
    let id = event.target.id;
    singleErrorCheck(id, value);
    if(id === 'phone_number') {
      value = value.split('-').join('');
      if(!isNumber(value)) {return}
      if(value.length >= 16) {
        return
      }
      value = value.length < 11 ? formatPhoneNumber(value) : value;
    } else if(id === 'password') {
      passwordValidation(value); 
    } else {
      value = value.trim();
    }
    setValues({ ...values, [property]: value });
  };

  let formatPhoneNumber = (phoneNumberString) => {
    phoneNumberString = phoneNumberString.split('-').join('');
    let newString = phoneNumberString.split('');
    if(newString.length > 3) {
      newString.splice(3, 0, '-');
      if(newString.length > 7) {
        newString.splice(7, 0, '-');
      }
    };
    newString = newString.join('');
    return newString
  }

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  let errorStyle = (id, property, style) => {document.getElementById(`${id}`).style[property] = style}

  let errorTarget = (id, value) => {
    let errors = false;
    // let errorStyle = (style) => {document.getElementById(`${id}-container`).style.borderBottom = style}
    if(value.length < 1){
      errorStyle(`${id}-container`, 'border', '1px solid #ef4b4b')
      errors = true;
    } else if (id === 'email') {
      if(!emailValidation(value)) {
        errorStyle(`${id}-container`, 'border', '3px solid #ef4b4b')
        // errorStyle('3px solid #5e76e8')
        errors = true;
      } else {
        errorStyle(`${id}-container`, 'border', '')
        // errorStyle('');
      }
    } else {
      errorStyle(`${id}-container`, 'border', '')
      // errorStyle('');
    }
    return errors;
  }

  let infoProps = ['first_name', 'last_name', 'phone_number', 'email', 'password'];
  let hasErrors = () => {
    let errors = [];
    let keys = infoProps;
    for(let i = 0; i < keys.length; i++) {
      let id = keys[i];
      let value = values[id];
      errors.push(errorTarget(id, value));
    }
    return errors.includes(true) || passwordIsValid === false ? true : false;
  }

  const isNumber = (value) => {
    let validNumbers = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
    for(let i = 0; i < value.length; i++) {
      if(!validNumbers.includes(value[i])) {
        return false;
      }
    }
    return true;
  }

  const isSpecialCharacter = (value) => {
    let validCharacters = ['(', '$', '@', '#', '!', '_', '%', '€', '£', ')', '&', '^'];
    for(let i = 0; i < value.length; i++) {
      if(!validCharacters.includes(value[i])) {
        return false;
      }
    }
    return true;
  }

  const isUpperCase = (value) => {
    let validCharacters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    for(let i = 0; i < value.length; i++) {
      if(!validCharacters.includes(value[i])) {
        return false;
      }
    }
    return true;
  }

  const isLowerCase = (value) => {
    let validCharacters = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"];
    for(let i = 0; i < value.length; i++) {
      if(!validCharacters.includes(value[i])) {
        return false;
      }
    }
    return true;
  }

  const singleErrorCheck = (target, value) => {
    errorTarget(target, value);
  }

  const emailValidation = (string) => {
    let mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if(string.match(mailFormat)){
      return true;
    } else {
      return false;
    }
  }

  // A minimum of 8 characters
  // Atleast 1 number
  // Atleast 1 uppercase
  // Atleast 1 lowercase
  // Atleast 1 wild character ($@#!_%€£)
  const [passwordIsValid, setPasswordIsValid] = React.useState(false);
  const [passwordIndicator, setPasswordIndicator] = React.useState([]);
  const passwordValidation = (password) => {
    let indicator = [];
    let indications = ['longEnough', 'isNumber', 'hasSpecial', 'isLower', 'isUpper'];
    if(password.length >= 8 && !indicator.includes('longEnough')) {
      indicator.push('longEnough');
      errorStyle('longEnough', 'textDecoration', 'line-through');
    }
    for(let i = 0; i < password.length; i++) {
      let value = password[i];
      if(isNumber(value) && !indicator.includes('isNumber')) {
        indicator.push('isNumber');
        errorStyle('isNumber', 'textDecoration', 'line-through')
      } else if(isSpecialCharacter(value) && !indicator.includes('hasSpecial')) {
        indicator.push('hasSpecial');
        errorStyle('hasSpecial', 'textDecoration', 'line-through');
      } else if(isLowerCase(value) && !indicator.includes('isLower')) {
        indicator.push('isLower');
        errorStyle('isLower', 'textDecoration', 'line-through');
      } else if(isUpperCase(value) && !indicator.includes('isUpper')) {
        indicator.push('isUpper');
        errorStyle('isUpper', 'textDecoration', 'line-through');
      }
    }
    for(let i = 0; i < indications.length; i++) {
      if(!indicator.includes(indications[i])) {
        errorStyle(indications[i], 'textDecoration', '')
      }
    }
    setPasswordIndicator(indicator);
  }

  useEffect(() => {
    if(passwordIndicator.length === 5) {
      setPasswordIsValid(true)
    } else {
      setPasswordIsValid(false)
    }
    // return () => {
    //   cleanup
    // }
  }, [passwordIndicator]);

  const [signInError, setSignInError] = React.useState(false);

  const signUpUser = () => {
    let tok =  btoa(`${props.unicycle}:${props.pencil}`);
    if(hasErrors()) {return}

    let data = JSON.stringify({
      "orgId": props.orgId,
      'firstName': values.first_name,
      'lastName': values.last_name,
      "email": values.email,
      "mobile": values.phone_number,
      "password": values.password,
      "signUpSource": signUpSource
    })

    axios.post('https://api.churchpad.com/p/signup/', data, {
        headers: { 
            'Authorization' : `Basic ${tok}`,
            'Content-Type': 'application/json',
        },
    }).then(res => {
        if(res.data.responseMessage === 'success') {
          window.location = res.data.responseData.successUrl;
        } else {
          setSignInError(res.data.responseMessage)
        }
    }).catch(err => {
        console.log(err);
    })
  }

  return (
    <main className="authentication signup">
      <header>
        <span className="icon" style={{backgroundColor: props.colors.secondary}}>
          <i className="las la-clipboard-check"></i>
        </span>
        <h3>Sign up</h3>
      </header>

      <form className="col s12">
        <div className="row get-name">
          <div className="input-field col s12 input-field-double" id="first_name-container">
            <input id="first_name" type="text" className="validate" onChange={handleChange('first_name')} value={values.first_name}/>
            <label htmlFor="first_name">First Name</label>
          </div>
        </div>
        <div className="row get-name">
          <div className="input-field col s12 input-field-double" id="last_name-container">
            <input id="last_name" type="text" className="validate" onChange={handleChange('last_name')} value={values.last_name}/>
            <label htmlFor="last_name">Last Name</label>
          </div>
        </div>
        <div className="row get-email">
          <div className="input-field col s12" id="email-container">
            <input id="email" type="text" className="validate" onChange={handleChange('email')} value={values.email}/>
            <label htmlFor="email">Email</label>
          </div>
        </div>
        <div className="row get-phone-number">
          <div className="input-field col s12" id="phone_number-container">
            <input id="phone_number" type="tel" pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}" className="validate" onChange={handleChange('phone_number')} value={values.phone_number}/>
            <label htmlFor="phone_number">Phone Number</label>
          </div>
        </div>
        <div className="row get-password">
          <div className="input-field col s12" id="password-container">
            <input id="password" type={values.showPassword ? "text" : "password"} className="validate" onChange={handleChange('password')} value={values.password}/>
            <label htmlFor="password">Password</label>
            <span className="show-hide-password waves-effect" onClick={handleClickShowPassword}><i className={`lar la-eye${values.showPassword ? '' : '-slash'}`} style={{color: props.colors.secondary}}></i></span>
          </div>
          <div className="password-indicator">
            <div className="indicators">
              {
                passwordIndicator.map((item, index) => {
                  return (
                    <span className="indicator slide_in" id={`indicator-${index}`} key={index}></span>
                  )
                })
              }
            </div>
            <div className={"indicator-text " + (passwordIsValid ? "display_none" : "")}>
              <h4><span>!</span> Password if not strong enough</h4>
              <ul>
                <li id="longEnough">• At least 8 characters</li>
                <li id="isNumber">• At least one number</li>
                <li id="isUpper">• At least 1 uppercase letter</li>
                <li id="isLower">• At least 1 lowercase letter</li>
                <li id="hasSpecial">• At least 1 special character ($@#!_%€£&^)</li>
              </ul>
            </div>
          </div>
        </div>
      </form>
      <div className="submit">
        <button className="signIn-button submit-btn" style={{backgroundColor: props.colors.secondary}} onClick={signUpUser}> <h4>Sign up</h4> </button>
      </div>

      <Link to={'/cp/signin'}>
        <div className="noAccount">
          <button className='waves-effect'>Already have an account? Sign In</button>
        </div>
      </Link>

      <div className="errorMessage">
        <h4 className="red-text">
          {signInError ? signInError : null}
        </h4>
      </div>
    </main>
  )
}
